import { RootState } from '@/store';
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  createDialog: { open: false }
} as {
  createDialog: { open: boolean };
};

const slice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    openCreateDialog: (state) => ({
      ...state,
      createDialog: { open: true }
    }),
    closeCreateDialog: (state) => ({
      ...state,
      createDialog: { open: false }
    })
  },
  extraReducers: () => {}
});

export const {
  openCreateDialog: openCreateUserDialog,
  closeCreateDialog: closeCreateUserDialog
} = slice.actions;

export default slice.reducer;

export const selectCreateUserDialog = (state: RootState): { open: boolean } =>
  state.user.createDialog;
